<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const zoomTooLow = ref(false);

const checkZoom = () => {
  zoomTooLow.value = window.devicePixelRatio * 100 < 50;
};

onMounted(() => {
  checkZoom();
  // Listen for zoom/DPR changes
  window.addEventListener('resize', checkZoom);
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', checkZoom);
});
</script>

<template>
  <ClientOnly>
    <div
      v-if="zoomTooLow"
      style="
        position: fixed;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: white;
        font-size: 2rem;
        z-index: 9999;
      "
    >
      🔍 Please reset your zoom to at least 50%
    </div>
    <NuxtLayout v-else>
      <NuxtPage />
    </NuxtLayout>
  </ClientOnly>
</template>